import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './store';

export default function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuth((s) => s.sessionActive);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
